import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/admin" className="navbar-brand">
          <span className="brand-name">MARTEU</span>
          <span className="brand-subtitle">Freight Admin</span>
        </Link>
        <ul className="navbar-menu">
          <li>
            <Link to="/admin" className={isActive('/admin')}>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/admin/providers" className={isActive('/admin/providers')}>
              Providers
            </Link>
          </li>
          <li>
            <Link to="/admin/shipments" className={isActive('/admin/shipments')}>
              Shipments
            </Link>
          </li>
          <li>
            <Link to="/admin/tasks" className={isActive('/admin/tasks')}>
              Tasks
            </Link>
          </li>
          <li>
            <Link to="/admin/analytics" className={isActive('/admin/analytics')}>
              Analytics
            </Link>
          </li>
          <li>
            <Link to="/admin/quote-explorer" className={isActive('/admin/quote-explorer')}>
              Quote Explorer
            </Link>
          </li>
          <li>
            <Link to="/admin/tenants" className={isActive('/admin/tenants')}>
              Tenants
            </Link>
          </li>
          <li>
            <Link to="/admin/prompts" className={isActive('/admin/prompts')}>
              Prompts
            </Link>
          </li>
          <li>
            <Link to="/admin/hub" className={isActive('/admin/hub')}>
              Admin
            </Link>
          </li>
        </ul>
        {user && (
          <div className="navbar-user">
            <span className="navbar-user-name">{user.name || user.email}</span>
            <button className="navbar-logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
